import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
} from '@mui/material';

import React from 'react';
import { MdDelete } from 'react-icons/md';

const ClusterConfigPage = ({
  uniqueId,
  columnName,
  selectedColumnName,
  handleUniqueId,
  handleAdd,
  handleDelete,
  configData,
  handleChange,
  disableForm,
}) => {
  const criteria = [
    {
      label: 'Fuzzy Unordered',
      value: 'fuzzy_unordered',
    },
    {
      label: 'Fuzzy',
      value: 'fuzzy',
    },
    {
      label: 'Fuzzy Or Null',
      value: 'fuzzy_or_null',
    },
    {
      label: 'Exact',
      value: 'exact',
    },
    {
      label: 'Exact Or Null',
      value: 'exact_or_null',
    },
  ];

  return (
    <Paper sx={{ width: '100%', height: '100%', minHeight: '400px', marginTop: '10px', padding: '20px' }}>
      <FormControl style={{ width: '23%' }} size="small">
        <InputLabel>Unique Id</InputLabel>
        <Select
          id="demo-simple-select-helper"
          value={uniqueId}
          onChange={handleUniqueId}
          size="small"
          label="Unique Id"
          name="uniqueId"
          sx={{ background: '#ffffff' }}
          disabled={disableForm}
        >
          {columnName
            .filter((columns) => (columns.label === uniqueId ? true : !selectedColumnName.includes(columns.label)))
            .map((item) => (
              <MenuItem key={item.id} value={item.label}>
                {item.label}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      {uniqueId && (
        <Box>
          {configData.map((data, i) => (
            <Box
              component="form"
              key={i}
              sx={{
                '& .MuiTextField-root': { m: 1, width: '35ch' },
                marginTop: '12px',
              }}
              noValidate
              autoComplete="off"
            >
              <FormControl style={{ width: '23%' }} size="small">
                <InputLabel>Column Name</InputLabel>
                <Select
                  id="demo-simple-select-helper"
                  name="column"
                  size="small"
                  label="Column Name"
                  value={data.column}
                  onChange={(e) => handleChange(e, i)}
                  key={data.id}
                  disabled={disableForm}
                  sx={{ background: '#ffffff' }}
                >
                  {columnName
                    .filter((columns) =>
                      columns.label === data.column ? true : !selectedColumnName.includes(columns.label)
                    )
                    .map((item) => (
                      <MenuItem key={item.id} value={item.label}>
                        {item.label}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              <FormControl style={{ width: '23%', marginLeft: '3%' }} size="small">
                <InputLabel>Matching Criteria</InputLabel>
                <Select
                  id="demo-simple-select-helper"
                  name="matchingCriteria"
                  size="small"
                  label="Matching Criteria"
                  value={data.matchingCriteria}
                  onChange={(e) => handleChange(e, i)}
                  key={data.id}
                  disabled={disableForm}
                  sx={{ background: '#ffffff' }}
                >
                  {criteria.map((item) => (
                    <MenuItem key={item.label} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {(data.matchingCriteria === 'fuzzy_unordered' ||
                data.matchingCriteria === 'fuzzy' ||
                data.matchingCriteria === 'fuzzy_or_null') && (
                <TextField
                  style={{ width: '23%', margin: '0px 0% 0px 3%' }}
                  label="Threshold"
                  id="outlined-size-small"
                  margin="none"
                  type="number"
                  name="threshold"
                  size="small"
                  disabled={disableForm}
                  onChange={(e) => handleChange(e, i)}
                  value={data.threshold}
                />
              )}
              <IconButton
                aria-label="expand row"
                size="medium"
                disabled={disableForm}
                onClick={() => handleDelete(data)}
              >
                <MdDelete />
              </IconButton>
            </Box>
          ))}
          <Grid container spacing={1} sx={{ mt: '2px' }}>
            <Grid item>
              <Button
                variant="contained"
                sx={{
                  display: 'flex',
                  alignContent: 'flex-start',
                  backgroundColor: '#00043C',
                  '&:hover': { backgroundColor: '#00043C' },
                }}
                onClick={handleAdd}
                disabled={disableForm}
              >
                Add
              </Button>
            </Grid>
          </Grid>
        </Box>
      )}
    </Paper>
  );
};

export default ClusterConfigPage;
